
import {defineComponent, PropType} from "vue";
import BaseBtModal from "@vueEntry/BaseBtModal.vue";
//@ts-ignore
import {useListingTypologyMultiselect} from "@wkComposables/useListingTypologyMultiselect";
import CheckboxBtn from "@vueEntry/UIKitComponents/Checkbox/CheckboxBtn.vue";
import {IListingTypology} from "@wikicasa/common/model/ListingTypology";
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import {Nullable} from "@customTypes/CustomUtilityTypes";

export default defineComponent({
    name: "ListingTypologyMultiSelectModal",
    components: {BaseButton, CheckboxBtn, BaseBtModal},
    props: {
        value: {
            type: Array as PropType<Array<number>>,
        },
        listingTypologies: {
            type: Array as PropType<Array<IListingTypology>>,
        },
        macroTypologyId: {
            type: Number
        },
        macroTypologyIdList: {
            type: Array as PropType<Nullable<Array<number>>>
        },
        name: {
            type: String
        },
        // To know if we are in the listing page or not
        listing: {
            type: Boolean,
        },
        className: {
            type: String
        },
        arrowColor: {
            type: String
        },
        showListingModal: {
            type: Boolean,
            required: true
        }
    },
    emits: ["close-listing-modal", "confirm-typologies", "input-object"],
    setup(props, context){
        const {
            //State
            selectedDTO,
            groups,
            originalLabel,
            //computed
            labels, selectedLabel,
            //methods
            decodeTextWithEntities,
            updateSelected,
            updateLabelAndIcon,
            generateGroups,
            getListingTypologyById,
            manageListingTypology,
            addListingTypology,
            isSelected,
            confirm,
            noGroupTypologiesIdList
        } = useListingTypologyMultiselect(context.emit)

        return {
            //state
            selectedDTO,
            groups,
            originalLabel,
            //computed
            labels, selectedLabel,
            //methods
            decodeTextWithEntities,
            updateSelected,
            updateLabelAndIcon,
            generateGroups,
            getListingTypologyById,
            manageListingTypology,
            addListingTypology,
            isSelected,
            confirm,
            noGroupTypologiesIdList
        }
    },
    data() {
        return {
            show: false,
        }
    },
    computed: {},
    watch: {
        value(curListingTypologyIdList, prevListingTypologyIdList) {
            if (curListingTypologyIdList.length === 1 && curListingTypologyIdList[0] === 0) {
                this.updateSelected(this.value, this.listingTypologies, this.macroTypologyId, this.macroTypologyIdList);
            } else if (curListingTypologyIdList.length === 0) {
                const previousListingTypology = this.getListingTypologyById(this.listingTypologies, prevListingTypologyIdList[0] || 0);

                if (this.noGroupTypologiesIdList(this.listingTypologies).find(id => id === previousListingTypology.listingTypologyId)) {
                    this.addListingTypology(this.listingTypologies[0]);
                    this.selectedDTO.group = this.listingTypologies[0].group;
                } else {
                    this.addListingTypology(this.listingTypologies[previousListingTypology.macroTypologyID - 1]);
                    this.selectedDTO.group = previousListingTypology.group;
                }
                this.confirm(false, true, this.listingTypologies);
            }
        }
    },
    created() {
        this.updateSelected(this.value, this.listingTypologies, this.macroTypologyId, this.macroTypologyIdList);
        this.show = this.showListingModal;
    },
    mounted() {
        this.generateGroups(this.listingTypologies);
        this.updateLabelAndIcon(this.listingTypologies);
    },
    methods: {
        manageConfirm(): void {
            this.$emit("confirm-typologies", this.selectedLabel);
            this.closeModal();
        },
        closeModal(): void {
            this.show = false;
        },
        isGroupIdSelected(id: number): boolean {
            return id === this.selectedDTO.macroTypologyID && this.selectedDTO.selectedListingTypologies[0].group !== "";
        }
    }
});
